import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=4432afc5"
import script from "./ApplicationView.vue?vue&type=script&lang=js"
export * from "./ApplicationView.vue?vue&type=script&lang=js"
import style0 from "../scss/global.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports